module.exports = __webpack_public_path__ + "img/book-02.383af6aa.png";